import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, typography, breakpoints, palette }) => ({
  root: {
    background: '#FFF',
    [breakpoints.up('lg')]: {
      padding: `${spacing(1)} ${spacing(1)}`
    }
  },
  container: {
    margin: '0',
    justifyContent: 'center',
    display: 'flex'
  },
  signUpContainer: {
    [breakpoints.down('lg')]: {
      order: 1
    }
  },
  contentGrid: {
    display: 'grid',
    gridTemplateAreas: `
      "progress      progress"
      "personalInfo  orderSummary"
      "paymentInfo   orderSummary"
    `,
    position: 'relative',
    gridTemplateColumns: ' 590px 1fr',
    // gridTemplateRows: '1fr 490px',
    [breakpoints.down('md')]: {
      gridTemplateAreas: `
      "progress"
      "personalInfo"
      "orderSummary"
      "paymentInfo"
    `,
      gridTemplateColumns: '1fr',
      background: '#F8F9FD'
    }

  },
  contentGridPayment: {
    gridTemplateRows: '1fr'
  },
  progress: {
    gridArea: 'progress',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing(2),
    [breakpoints.down('md')]: {
      margin: spacing(2, 5, 0, 5)

    }
  },
  personalInfo: {
    gridArea: 'personalInfo',
    marginRight: spacing(2),
    [breakpoints.down('md')]: {
      margin: '0 auto',
      width: '95%'
    }
  },
  paymentInfo: {
    gridArea: 'paymentInfo',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%', /* Adjust if needed */
    marginRight: spacing(2),
    [breakpoints.down('lg')]: {
      marginRight: 0,
      marginBottom: 0
    }
  },
  orderSummary: {
    gridArea: 'orderSummary',
    maxWidth: 'auto'
  },
  signUpBox: {
    background: '#F8F9FD',
    padding: `${spacing(2)} ${spacing(4)}`
  },
  summaryBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: `${spacing(2)} ${spacing(4)}`,
    background: '#F8F9FD'
  },
  socialButton: {
    border: '1px solid #B9B7BD',
    padding: '10px 24px 10px 8px',
    boxShadow: '0px 1px 3px rgba(24, 24, 24, 0.1), 0px 1px 2px rgba(24, 24, 24, 0.06)',
    borderRadius: '4px',
    flex: 1
  },
  socialIcon: {
    height: '30px',
    width: '30px'
  },
  priceBox: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    '& p:first-child': {
      flex: 1
    },
    marginBottom: spacing(1)
  },
  sectionTitle: {
    ...typography.heading.h4,
    flex: 1,
    fontWeight: 'bold'
  },
  totalLabel: {
    fontWeight: 500
  },
  divider: {
    marginTop: spacing(1),
    marginBottom: spacing(1)
  },
  dividerOr: {
    flex: 1,
    display: 'flex'
  },
  guidanceContainer: {
    background: '#F8F9FD',
    padding: `${spacing(0)} ${spacing(2)}`
  },
  passwordStrengthContainer: {
    height: spacing(0.5),
    gap: spacing(0.5),
    padding: `${spacing(0)} ${spacing(2)}`
  },
  passwordStrengthItem: {
    background: 'rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    flex: 1
  },
  passwordStrengthItemFilled: {
    background: 'red'
  },
  freeLimitedWarning: {
    background: '#F5F5F5',
    padding: `${spacing(2)} 0px`,
    textAlign: 'center',
    marginTop: spacing(2),
    marginBottom: spacing(1)
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  dialogSelectContainer: {
    [breakpoints.down('sm')]: {
      width: '100%'
    }
  }

}))
